import { Maybe } from 'types';

const REGEXP_SCROLL_PARENT = /^(visible|hidden)/;
const REGEXP_CLASS_NAME = /ant-select/;

// Find the first scrollable parent - to be used to set the container for popups so they scroll with the page
export const getScrollParent = (el: Maybe<HTMLElement>): HTMLElement =>
  !(el instanceof HTMLElement)
    ? document.body
    : el.scrollHeight >= el.clientHeight &&
      !REGEXP_SCROLL_PARENT.test(window.getComputedStyle(el).overflowY || 'visible') &&
      !REGEXP_CLASS_NAME.test(el.className)
    ? el
    : getScrollParent(el.parentElement) || document.body;
